var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAmpIdentifier(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.414 7.722L7.85 13.656h-.646l.638-3.867-2.005.003a.322.322 0 01-.323-.322c0-.077.071-.206.071-.206L9.14 3.337l.657.003-.655 3.872 2.02-.003a.323.323 0 01.322.323.315.315 0 01-.068.19zM8.5 0A8.5 8.5 0 000 8.5 8.5 8.5 0 108.5 0z",
    fill: "#9A9A9A"
  })));
}

export default SvgAmpIdentifier;